/**
 * This file is responsible for rendering the account registration page in the application.
 *
 * The component uses server-side rendering (getServerSideProps) to fetch the translations for the page.
 *
 *
 *
 * The Register component from '~/ui/pages/User/Register' is used to render the registration form.
 *
 * If there's an error during server-side rendering, it is passed as a prop to the NextPage component and can be used to display an error message.
 *
 * The NextPage component from '~/ui/layouts/NextPage' is used to render the page layout.
 */

import { ReactElement } from 'react';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { NextPage, RegisterPage as Register } from '@Hotels-at-Home/hah-fe-core/dist/components';

import { TServerSideProps } from '@Hotels-at-Home/hah-fe-core/dist/types';
import { usePageViewEvent } from '@Hotels-at-Home/hah-fe-core/dist/hooks';

import Services from '~/ui/components/common/Services';
import { homeServicesMock } from '~/ui/components/common/Services/servicesMock';

import { LOGIN } from '@Hotels-at-Home/hah-fe-core/dist/constants';

const RegisterPage = (props: TServerSideProps): ReactElement => {
  const { error } = props;

  const { t } = useTranslation('', { keyPrefix: '' });
  const { t: tRegister } = useTranslation('', { keyPrefix: '$local.$register' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  usePageViewEvent();

  const meta = {
    title: `${t('$local.$meta.meta_title')} - ${t('$common.$labels.settings')} - ${t(
      '$common.$labels.createAccount',
    )}`,
    description: `${t('$local.$meta.meta_title')} - ${t('$common.$labels.settings')} - ${t(
      '$common.$labels.createAccount',
    )}`,
  };

  return (
    <NextPage error={error} meta={meta}>
      <div className="account-container register-page">
        <div className="img-wrap">
          <img src="/images/misc/filler.gif" alt="scent" width="100%" height="auto" />
        </div>
        <div className="register-container">
          <Register showHCaptcha />
          <p>
            {tRegister('returningCostumer')}
            <a href={`${LOGIN}`}>{tButton('signIn')}</a>
          </p>
        </div>
      </div>
      <div className="register-services">
        <Services items={homeServicesMock} border={false} />
      </div>
    </NextPage>
  );
};

export const getServerSideProps: GetServerSideProps = async ctx => {
  const props: TServerSideProps = {
    ...(await serverSideTranslations(ctx.locale)),
    error: null,
  };

  return { props };
};

export default RegisterPage;
